import React, { Component, Fragment } from "react";
import { Form, Button } from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { observer, inject } from "mobx-react";
import { autorun, toJS } from "mobx";
import styles from "./index.module.less";
import { ModuleMap, ModuleValue } from "common/modules";

const FormItem = Form.Item;

function getTextFilter() {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for sites</div>' +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="Site url..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter the sites that you want to search for</div>' +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			// console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

function strcmp(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

@inject("rootStore")
@observer
export default class SimpleSiteList extends Component {
	constructor(props) {
		super(props);
	}

	componentWillUnmount() {}

	onGridReady(params) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		this.gridApi.forEachNode(node => {
			if (node.group == false) {
				node.setSelected(node.data.checked, false, false, false);
			}
		});

		let selectedSiteCount = this.props.sites.reduce((count, site) => {
			if (site.checked) {
				count++;
			}
			return count;
		}, 0);
		this.setState({
			selectedSiteCount: selectedSiteCount
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.gridApi) {
			return;
		}
	}

	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: columnDefs,
			groupDefaultExpanded: -1,
			autoGroupColumnDef: {
				headerName: "Site",
				field: "id.siteId",
				filter: "agTextColumnFilter",
				headerCheckboxSelection: () => {
					return true;
				},
				headerCheckboxSelectionFilteredOnly: true,
				width: 300,
				editable: false,
				cellRenderer: "agGroupCellRenderer",
				cellRendererParams: {
					checkbox: true,
					readOnly: () => {
						return false;
					}
				},
				suppressSorting: true
			},
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	componentDidMount() {}

	collapseAll = () => {
		this.gridApi.collapseAll();
	};

	expandAll = () => {
		this.gridApi.expandAll();
	};

	resetAllFilters = () => {
		this.gridApi.setFilterModel(null);
		this.gridApi.onFilterChanged();
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	onSelectionChanged = event => {
		this.setState({
			selectedSiteCount: event.api.getSelectedNodes().length
		});
	};

	updateRow = row => {
		// row.modulePlatform = ModuleMap[row.id.module] + ": " + row.platform;
		this.gridApi.updateRowData({
			update: [row]
		});
	};

	getRowData = () => {
		if (this.gridApi == null) {
			return [];
		} else {
			let rowData = [];
			this.gridApi.forEachNode(node => {
				if (node.group == false) {
					rowData.push(node.data);
				}
			});
			return rowData;
		}
	};

	render() {
		if (this.props.sites.length == 0) {
			return <div />;
		} else {
			// const gridDefs = this.state.gridDefs;
			const props = this.props;
			const gridDefs = this.createGridDefs(this.props.columnDefs);
			// this.rowData = toJS(this.props.sites);

			let totalSiteCount = this.props.sites.length;
			
			let selectedSiteCount = this.props.sites.reduce((count, site) => {
				if (site.checked) {
					count++;
				}
				return count;
			}, 0);


			return (
				<Fragment>
					<div className="ant-form ant-form-inline">
						<FormItem>
							<Button type="primary" icon="minus" onClick={this.collapseAll}>
								Collapse
							</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" icon="plus" onClick={this.expandAll}>
								Expand
							</Button>
						</FormItem>
						<FormItem>
							<Button
								type="primary"
								icon="filter"
								onClick={this.resetAllFilters}
							>
								Clear Filter
							</Button>
						</FormItem>
						<FormItem>
							<span className={styles.status}>
								Selected Sites: {selectedSiteCount}
							</span>
						</FormItem>
						<FormItem>
							<span className={styles.status}>
								Total Sites: {totalSiteCount}
							</span>
						</FormItem>
					</div>

					<div
						style={{
							boxSizing: "border-box",
							height: "100%",
							width: "100%"
						}}
						className="ag-theme-balham"
					>
						<AgGridReact
							columnDefs={gridDefs.columnDefs}
							enableColResize={true}
							enableFilter={true}
							floatingFilter={true}
							enableSorting={true}
							groupSelectsChildren={true}
							groupDefaultExpanded={gridDefs.groupDefaultExpanded}
							autoGroupColumnDef={gridDefs.autoGroupColumnDef}
							defaultColDef={gridDefs.defaultColDef}
							rowData={this.props.sites}
							enableRangeSelection={true}
							rowSelection={gridDefs.rowSelection}
							suppressRowClickSelection={true}
							onRowSelected={this.onRowSelected}
							onSelectionChanged={this.onSelectionChanged}
							getRowNodeId={data => {
								return data.id.module + "_" + data.id.siteId;
							}}
							defaultGroupSortComparator={(nodeA, nodeB) => {
								var valueA = nodeA.key;
								var valueB = nodeB.key;
								if (ModuleValue[nodeA.key] != undefined) {
									valueA = ModuleValue[nodeA.key];
									valueB = ModuleValue[nodeB.key];
								}
								if (valueA === "Premium") {
									return -1;
								}
								if (valueB === "Premium") {
									return 1;
								}
								if (valueA < valueB) {
									return -1;
								} else if (valueA > valueB) {
									return 1;
								} else {
									return 0;
								}
							}}
							onSortChanged={e => {
								// console.log(e.api.getSortModel());
							}}
							deltaRowDataMode={true}
							onGridReady={this.onGridReady.bind(this)}
						/>
					</div>
				</Fragment>
			);
		}
	}
}
